export function makePhoneValidation<T>(errorMsg: T) {
  // eslint-disable-next-line
  const re = /^[-\s+\(\)\.\d]*$/;
  return (phone: string) => (re.test(String(phone).toLowerCase()) ? undefined : errorMsg);
}
